import { Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { EditorialType, ExportOptions } from '../../domain/domain';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import {
    isEditorialTypeSelected,
    setEditorialTypeSelected,
    getVisibleEditorialTypes,
    filterEditorialTypesByUserRole
} from './editorialContentHelpers';

type EditorialContentSelectPanelProps = {
    exportOptions: ExportOptions,
    onExportOptionsChanged: (exportOptions: ExportOptions) => void
}

const EditorialContentSelectPanel: React.FC<EditorialContentSelectPanelProps> = ({
    exportOptions,
    onExportOptionsChanged
}) => {
    const currentUser = useSelector((app: ApplicationState) => app.user.currentUser);

    useEffect(() => {
        const updatedOptions = filterEditorialTypesByUserRole(exportOptions, currentUser);

        // Only update if something changed
        if (updatedOptions !== exportOptions) {
            onExportOptionsChanged(updatedOptions);
        }
    }, [currentUser, exportOptions, onExportOptionsChanged]);

    const renderCheckbox = (editorialType: EditorialType, label: string) => (
        <Grid item key={editorialType}>
            <FormControlLabel
                control={
                    <Checkbox
                        size='small'
                        onChange={(event) => {
                            onExportOptionsChanged(
                                setEditorialTypeSelected(exportOptions, editorialType, event.target.checked)
                            )
                        }}
                        checked={isEditorialTypeSelected(exportOptions, editorialType)}
                    />
                }
                label={label}
            />
        </Grid>
    );

    const visibleTypes = getVisibleEditorialTypes(currentUser);
    const midpoint = Math.ceil(visibleTypes.length / 2);

    return (
        <Grid container direction='column' className="flex-gap-1">
            <Grid item>
                <Typography>Editorial Content</Typography>
            </Grid>
            <Grid item>
                <Grid container direction='row' wrap='nowrap'>
                    <Grid item xs={6} style={{ minWidth: '160px' }}>
                        <Grid container direction='column' className="flex-gap-1">
                            {visibleTypes.slice(0, midpoint).map(({ type, label }) =>
                                renderCheckbox(type, label)
                            )}
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container direction='column' className="flex-gap-1">
                            {visibleTypes.slice(midpoint).map(({ type, label }) =>
                                renderCheckbox(type, label)
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default EditorialContentSelectPanel;